import React from 'react';

const NoRowsOverlay: React.FC = () => {
  return (
    <div style={{ 
      padding: '20px', 
      textAlign: 'center',
      color: '#666'
    }}>
      No data to display. Upload a CSV or Excel file to begin.
    </div>
  );
};

export default NoRowsOverlay;
